<template>
    <div>
      <div class="container">
        <h2>This online service is currently under construction and hence unavailable. We apologize for the inconvenience.</h2>
      </div>
    </div>
</template>


<script setup>
defineOptions({
  name: 'Maintenance'
})
</script>


<style>
.container {
    padding: 15px;
    margin: 1.5rem;
}
</style>